const getStaticTranslations = (localeCode = 'en-GB') => {
  const staticTranslationData = require(`../common/locales/${localeCode}/static-translations.json`);
  return staticTranslationData;
};

const getPageTypeTranslations = (localeCode = 'en-GB') => {
  const pageTypeTranslationData = require(`../common/locales/${localeCode}/page-type-translations.json`);
  return pageTypeTranslationData;
};

const getContentHubData = (localeCode = 'en-GB') => {
  const ContentHubData = require(`../locales/${localeCode}/data/content-hub.data.json`);
  return ContentHubData;
};

const getFooterData = (localeCode = 'en-GB') => {
  const footerData = require(`../locales/${localeCode}/data/footer.data.js`);
  return footerData;
};

const getHomePageData = (localeCode = 'en-GB') => {
  const homePageData = require(`../locales/${localeCode}/data/home-page.data.js`);
  return homePageData;
};

module.exports = {
  getStaticTranslations,
  getPageTypeTranslations,
  getContentHubData,
  getFooterData,
  getHomePageData,
};
